import { mapState } from 'vuex';
import MapOverlayAnchorProjectionService from '../../../../../services/mapOverlayAnchorProjectionService';
import WGS84Service from '../../../../../services/wgs84ProjectionService';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreDtwinMapOverlayWizardContainer',
  props: {
    addressObject: {
      type: Object,
      required: false,
      default: () => ({})
    },
    twinImages: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {
      overlayImageId: null,
      imageFileName: null,
      imageSrc: null,
      rotatedImage: null,
      anchorCanvasWidth: 0,
      anchor1: {
        position: {},
        latlon: {}
      },
      anchor2: {
        position: {},
        latlon: {}
      },
      processedInfo: {
        image: null,
        ne: {},
        sw: {}
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'UiTheme']),
    hasCompleteInfo() {
      if (!this.anchor1.position.x || !this.anchor1.latlon.lat) {
        return false;
      }
      if (!this.anchor2.position.x || !this.anchor2.latlon.lat) {
        return false;
      }
      return true;
    },
    overlayInfo() {
      if (!this.processedInfo.image) {
        return null;
      }
      if (!WGS84Service.isValidWgs84(this.processedInfo.ne)) {
        return null;
      }
      if (!WGS84Service.isValidWgs84(this.processedInfo.sw)) {
        return null;
      }
      // https://docs.mapbox.com/mapbox-gl-js/style-spec/sources/#image
      // https://docs.mapbox.com/mapbox-gl-js/example/image-on-a-map/
      return {
        image: this.processedInfo.image,
        coordinates: [[this.processedInfo.sw.lon, this.processedInfo.ne.lat], [this.processedInfo.ne.lon, this.processedInfo.ne.lat], [this.processedInfo.ne.lon, this.processedInfo.sw.lat], [this.processedInfo.sw.lon, this.processedInfo.sw.lat]]
      };
    }
  },
  watch: {
    imageSrc() {
      this.debouncedCanvasWidthCalc();
    }
  },
  mounted() {
    this.debouncedCanvasWidthCalc();
  },
  created() {
    window.addEventListener('resize', this.debouncedCanvasWidthCalc);
  },
  destroyed() {
    window.removeEventListener('resize', this.debouncedCanvasWidthCalc);
  },
  methods: {
    getAttachmentDownloadUrl(file) {
      return `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}/upload/${file.id}`;
    },
    overlayImageSelected() {
      if (this.overlayImageId) {
        this.imageFileName = this.twinImages.find(f => f.id === this.overlayImageId).name;
        this.imageSrc = this.getAttachmentDownloadUrl({
          id: this.overlayImageId
        });
      } else {
        this.imageFileName = null;
        this.imageSrc = null;
      }
    },
    debouncedCanvasWidthCalc: debounce(function () {
      this.anchorCanvasWidth = this.$refs['image-anchor-picker-container'].clientWidth;
    }, 250),
    onFileChange(e) {
      e.stopPropagation();
      e.preventDefault();
      const files = (e.target || {}).files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.handleFile(files[0]);
    },
    handleFile(file) {
      if (file.type.match(/image.*/)) {
        this.imageFileName = file.name;
        const context = this;
        const reader = new FileReader();
        reader.onload = e => {
          context.imageSrc = e.target.result;
          // TODO: SETUP MAP HERE
          // context.$refs.gmaps.resetMap();
        };
        reader.readAsDataURL(file);
      }
    },
    handleDragOver(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    updateAnchor1Position(position) {
      this.anchor1.position = position;
    },
    updateAnchor2Position(position) {
      this.anchor2.position = position;
    },
    movedAnchor1Coordinate(coordinate) {
      this.anchor1.latlon = coordinate;
    },
    movedAnchor2Coordinate(coordinate) {
      this.anchor2.latlon = coordinate;
    },
    processOverlayImage() {
      const canvas = this.$refs['image-anchor-picker'];
      const anchors = [{
        screenPoint: this.anchor1.position,
        coordinate: this.anchor1.latlon
      }, {
        screenPoint: this.anchor2.position,
        coordinate: this.anchor2.latlon
      }];
      const info = MapOverlayAnchorProjectionService.getBoundsAndRotation(anchors, canvas.image.orgDimension.width, canvas.image.orgDimension.height);
      const tempCanvas = document.createElement('canvas');
      tempCanvas.setAttribute('width', info.size.width);
      tempCanvas.setAttribute('height', info.size.height);
      const context = tempCanvas.getContext('2d');

      // http://stackoverflow.com/a/5983173/5460596
      const image = canvas.image.htmlEl;
      context.translate(0.5 * image.width, 0.5 * image.height);
      const resizedWidth = 0.5 * (info.size.width - image.width);
      const resizedHeight = 0.5 * (info.size.height - image.height);
      context.translate(resizedWidth, resizedHeight);
      context.rotate(info.rotation);
      context.drawImage(image, -image.width * 0.5, -image.height * 0.5);
      context.restore();
      const img = tempCanvas.toDataURL('image/png');
      this.processedInfo = {
        image: img,
        imageFileName: this.imageFileName,
        ne: {
          lat: info.north,
          lon: info.east
        },
        sw: {
          lat: info.south,
          lon: info.west
        }
      };
    }
  }
};